export const ExternalVar = "ext-data";
export const ExternalVarExpiry = 300;
export const ExternalPopupId = "seekcap-external-login";
export const ExternalCallback = "/callback/[action]";
export const ExternalMonitorFrequency = 500; // in milliseconds
export const ExternalActions = {
    UT001_EXT: {
        "development": {
            authURL: "http://some-website.comredirect_uri=[callback-url]",
            action: "lazada",
            expiry: 1800,
            formTabIndex: 1,
        },
        "staging": {
            authURL: "http://some-website.comredirect_uri=[callback-url]",
            action: "lazada",
            expiry: 1800,
            formTabIndex: 1,
        },
        "production": {
            authURL: "http://some-website.comredirect_uri=[callback-url]",
            action: "lazada",
            expiry: 1800,
            formTabIndex: 1,
        },
    },
    UBP001_LAZADA: {
        "development": {
            authURL:
                "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=122995&country=ph&redirect_uri=[callback-url]",
            action: "lazada",
            expiry: 1800,
            formTabIndex: 1,
        },
        "staging": {
            authURL:
                "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=122893&country=ph&redirect_uri=[callback-url]",
            action: "lazada",
            expiry: 1800,
            formTabIndex: 1,
        },
        "production": {
            authURL:
                "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=121969&country=ph&redirect_uri=[callback-url]",
            action: "lazada",
            expiry: 1800,
            formTabIndex: 1,
        },
    },
    PB001_NETB: {
        "development": {
            authURL:
                "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=122995&country=ph&redirect_uri=[callback-url]",
            action: "lazadanetb",
            expiry: 1800,
            formTabIndex: 1,
        },
        "staging": {
            authURL:
                "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=122893&country=ph&redirect_uri=[callback-url]",
            action: "lazadanetb",
            expiry: 1800,
            formTabIndex: 1,
        },
        "production": {
            authURL:
                "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=121969&country=ph&redirect_uri=[callback-url]",
            action: "lazadanetb",
            expiry: 1800,
            formTabIndex: 1,
        },
    },
    UBP001_SHPFY: {
        "development": {
            //authURL: "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=102226&country=ph&redirect_uri=[callback-url]",
            action: "ecommerce",
            expiry: 1800,
            formTabIndex: 1,
        },
        "staging": {
            //authURL: "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=102226&country=ph&redirect_uri=[callback-url]",
            action: "ecommerce",
            expiry: 1800,
            formTabIndex: 1,
        },
        "production": {
            // authURL: "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=122995&country=ph&redirect_uri=[callback-url]",
            action: "ecommerce",
            expiry: 1800,
            formTabIndex: 1,
        },
    },
    UBP001_WOCMRS: {
        "development": {
            // authURL: "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=102226&country=ph&redirect_uri=[callback-url]",
            action: "ecommerce",
            expiry: 1800,
            formTabIndex: 1,
        },
        "staging": {
            // authURL: "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=102226&country=ph&redirect_uri=[callback-url]",
            action: "ecommerce",
            expiry: 1800,
            formTabIndex: 1,
        },
        "production": {
            // authURL: "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&client_id=122995&country=ph&redirect_uri=[callback-url]",
            action: "ecommerce",
            expiry: 1800,
            formTabIndex: 1,
        },
    },
};

export const ExternalFieldMap = {
    UT001_EXT: {
        "test_field_1": "testField1",
    },
    UBP001_LAZADA: {
        "payout_in_3_months": "lazadaPayout3mth",
        "payout_in_6_months": "lazadaPayout6mth",
        "payout_in_12_months": "lazadaPayout12mths",
        "payout_in_15_months": "lazadaPayout15mth",
        "refund_in_6_months": "lazadaRefund6mth",
        "earliest_payout_years": "lazadaSinceEarliestPayoutYrs",
        "positive_seller_rating": "lazadaPositiveSellerRating",
        "ship_on_time": "lazadaShipOnTime",
    },
    PB001_NETB: {
        "payout_in_3_months": "applicMonthlyRepay",
        "payout_in_6_months": "applicOtherLoansAmt",
        "payout_in_12_months": "applicOverdraftAmt",
        "payout_in_15_months": "companyRevenue",
        "refund_in_6_months": "houseInfos_evaluation",
        "earliest_payout_years": "companyAnnualRevenue",
        "positive_seller_rating": "companyAssetSize",
        "ship_on_time": "companyOSDebt",
    },
};

export const NPSSurveyUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSdml1k14EbZz21EnPdOih3Ybh8vd8_GaNgOqNRzOJO1p-c7Wg/viewform";

export const Captcha = {
    development: {
        key: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    },
    staging: {
        key: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    },
    production: {
        key: "6LfuxfMaAAAAABcSicrHZoI616w6QUcj8c5AS70r",
    },
};
